export const BUILD_ENVIRONMENT_NAMES = {
  TESTING: 'testing',
  STAGING: 'staging',
  QA: 'qa',
  PRODUCTION: 'production',
  UNIT_TESTING: 'jest',
};

const API_DOMAIN_MAP = {
  // Local dev-server should just work with no domain.
  'dev-server': '',
  local: 'https://dobby.localhost',
  development: 'https://copilot-api.dev-formstack.com',
  testing: 'https://copilot-api.testing-formstack.com',
  qa: 'https://copilot-api.qa-formstack.com',
  staging: 'https://copilot-api.staging-formstack.com',
  production: 'https://copilot-api.formstack.com',
  jest: 'https://copilot-api.unit-testing-formstack.com',
};

const envHasDomain = (env?: string): env is keyof typeof API_DOMAIN_MAP =>
  env !== undefined && Object.keys(API_DOMAIN_MAP).includes(env);

const IS_LOCAL = process.env.COPILOT_BUILD_ENV === 'local';
const API_BASE_URL =
  (envHasDomain(process.env.COPILOT_BUILD_ENV) && API_DOMAIN_MAP[process.env.COPILOT_BUILD_ENV]) ||
  '';

/**
 * @param localPort What is the port of the service when running the back-end locally?
 * @param path What is the main path for this URL?
 * @param livePrefix Is there a prefix added to the URL when running in a live environment?
 *
 * @returns {string} The full base URL.
 * */
export const getFullAPIUrl = (path: string = ''): string =>
  `${API_BASE_URL}${IS_LOCAL ? `:3020/local` : ''}${path}`;

export const getFullAuthUrl = (path: string = ''): string =>
  `${API_BASE_URL}${IS_LOCAL ? `:3000/local` : '/auth'}${path}`;

export const AUTH_FROM_LOCAL = process.env.AUTH_TO_LOCAL === 'true';
export const USER_LOGIN_URL = getFullAuthUrl('/login');
export const USER_LOGOUT_URL = getFullAuthUrl('/logout');
export const CHECK_AUTH_URL = getFullAuthUrl('/user-info');
